import React from 'react';
import { User } from 'lucide-react';
import styled from 'styled-components';

const AvatarWrapper = styled.button`
  position: relative;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid #00f7d2;
    outline-offset: 2px;
  }
`;

const Avatar = styled.img`
  height: 38px;
  width: 38px;
  border-radius: 50%;
  border: 2px solid #00f7d2;
`;

const AvatarIcon = styled.div`
  height: 38px;
  width: 38px;
  border-radius: 50%;
  border: 2px solid #00f7d2;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.08);
  color: #e5e7eb;
`;

const StatusDot = styled.div`
  position: absolute;
  bottom: 2px;
  right: 2px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #22c55e;
  border: 2px solid #0b0e14;
`;

const AvatarButton = ({
  profileImage,
  avatarButtonRef,
  profileMenuOpen,
  toggleProfileMenu,
}) => (
  <AvatarWrapper
    ref={avatarButtonRef}
    type="button"
    aria-label="Account menu"
    onClick={toggleProfileMenu}
    aria-expanded={profileMenuOpen}
    aria-haspopup="true"
  >
    {profileImage ? (
      <Avatar src={profileImage} alt="Profile" />
    ) : (
      <AvatarIcon>
        <User size={22} />
      </AvatarIcon>
    )}
    <StatusDot />
  </AvatarWrapper>
);

export default AvatarButton;

